import { BaseState, StateManager } from '@app/store/shared';
import { createReducer, on } from '@ngrx/store';
import { certificatesActions } from '../actions/certificates.actions';
import { Certificate } from '../models';

export interface CertificatesState {
    certificates: BaseState<Certificate[]>;
}

const initialState: CertificatesState = {
    certificates: StateManager.initial(),
};

export const certificatesReducer = createReducer(
    initialState,

    on(certificatesActions.getCertificates, (state): CertificatesState => ({
        ...state,
        certificates: StateManager.setLoading(state.certificates),
    })),
    on(certificatesActions.getCertificatesSuccess, (state, { payload }): CertificatesState => ({
        ...state,
        certificates: StateManager.setLoaded(state.certificates, payload),
    })),
    on(certificatesActions.getCertificatesError, (state): CertificatesState => ({
        ...state,
        certificates: StateManager.setError(state.certificates),
    })),

    on(certificatesActions.clear, (): CertificatesState => ({
        ...initialState,
    })),
);
